import React, { ReactElement, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import useKeyboardShortcuts from "../../../contexts/KeyboardShortcutContext";
import useSelectionState, { Ticket } from "../../../pages/agent/selection-state";
import { NoDataOrError } from "../../../pages/error/Error";
import {
    ChatStatus, useLeaveParticipantMutation, useParticiapntAddSettingsQuery,
} from "../../../__generated__/api";
import Confirm from "../../confirm/Confirm";
import Loading from "../../loading/Loading";

export default function ParticipantsLeave(): ReactElement {
    const selectionState = useSelectionState();
    const { data, loading, error } = useParticiapntAddSettingsQuery();
    const [leaveParticipant] = useLeaveParticipantMutation();

    const [shouldShow, setShouldShow] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const inputRef = React.createRef<HTMLTextAreaElement>();
    const [selectedTicketIds, setSelectedTicketIds] = useState<string[]>([]);

    useEffect(() => {
        if (shouldShow && inputRef) {
            inputRef.current?.focus();
        }
        setMessage("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldShow]);

    const removeParticipant = async () => {
        setShouldShow(false);
        await leaveParticipant({
            variables: {
                participant: {
                    chatIds: selectedTicketIds,
                    note: message,
                },
            },
        });

        selectionState.closeCurrent();
    };

    const startLeave = (tickets?: Ticket[]) => {
        const selected = tickets ?? selectionState.getSelection().filter(row => row.isCurrentUserParticipating
            && row.status !== ChatStatus.ChatRequested
            && row.status !== ChatStatus.Connected);
        setSelectedTicketIds(selected.toIdList("id"));
        if (selected.isNotEmpty) {
            setShouldShow(true);
        }
    };

    useKeyboardShortcuts(shortcuts => {
        shortcuts.on({
            shortcut: "k+l",
            context: "default",
            description: "Leave a conversation currently participting in.",
            group: "Conversations",
            handler: () => startLeave(),
        });
    });

    selectionState.registerLeaveHandler(startLeave);

    if (loading) {
        return <Loading />;
    }
    if (!data || error) {
        return <NoDataOrError error={error} />;
    }

    return (
        <Confirm
            confirmText="Leave Chat"
            shouldShow={shouldShow}
            closeText="Close"
            onHide={() => setShouldShow(false)}
            onConfirm={() => removeParticipant()}
        >
            <div className="flex-grow-1 p-3 d-flex flex-column">
                <h5 className="mb-4">
                    Leave Chat
                </h5>
                <Form.Label className="text-primary">
                    Comments
                </Form.Label>
                <Form.Control
                    as="textarea"
                    type="text"
                    ref={inputRef}
                    placeholder="Looks ok to me now..."
                    className="default-text-height p-2"
                    onChange={evt => setMessage(evt.target.value)}
                />
                <Form.Text>
                    Any additional notes or comments you want to leave on this ticket?
                </Form.Text>

            </div>
        </Confirm>
    );
}

ParticipantsLeave.defaultProps = {
    refreshData: () => {
        // nothing
    },
};
